import CompanyPropertiesListContent from "../../features/companyProperties/widgets/CompanyPropertiesListContent";

function CompanyPropertiesListScreen() {
  return <CompanyPropertiesListContent />;
}

export default CompanyPropertiesListScreen;
